import { render, staticRenderFns } from "./AttributeEditor.vue?vue&type=template&id=46994c6e&scoped=true"
import script from "./AttributeEditor.vue?vue&type=script&lang=ts"
export * from "./AttributeEditor.vue?vue&type=script&lang=ts"
import style0 from "./AttributeEditor.vue?vue&type=style&index=0&id=46994c6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46994c6e",
  null
  
)

export default component.exports